import { useEffect, useState } from 'react';
import NewsSliderRows from '../../components/news/NewsSliderRows';

export default function News() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let active = true;
    fetch('/api/news/content?category=nigeria')
      .then((response) => { if (!response.ok) throw new Error('News request failed'); return response.json(); })
      .then((data) => { if (active) setItems(data.data || []); })
      .catch(() => { if (active) setItems([]); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);
  return <div className="px-4 py-16"><NewsSliderRows title="News" items={items} loading={loading} /></div>;
}
